// extracted by mini-css-extract-plugin
export default {"ErrorPage":"zrBql0y0MlCFC0OaNMgX","ErrorPage_content":"ZwonZai0AbHtKFryymQX"};